export const isFromCareConnect = () => {
  if (window.location.search.includes('from_care_connect=true')) {
    return true;
  }
  return false;
};

export const getSuccessfulLoginUrl = (accessToken) => {
  if (isFromCareConnect()) {
    return `/virtual-care-assistant/${accessToken}?from_care_connect=true&success`;
  } else {
    return `/virtual-care-assistant/${accessToken}?success`;
  }
};

export const getPreLoginUrl = (accessToken) => {
  if (isFromCareConnect()) {
    return `/virtual-care-assistant/${accessToken}?from_care_connect=true`;
  } else {
    return `/virtual-care-assistant/${accessToken}`;
  }
};

export const getChatUrl = () => {
  const parts = window.location.pathname.split('/');
  if (parts.length > 2) {
    return `/${parts[2]}`;
  } else {
    return '/';
  }
};
